import React from 'react'
import BannerForm from './form'
import BannerList from './list'

const Banner = () => {
  return (
    <>
      <BannerForm />
      <BannerList />
    </>
  )
}

export default Banner
